import {
  enUS,
  frFR,
  esES,
  zhHK,
  arSD,
  ukUA,
  koKR,
  bnBD,
  roRO,
  hrHR,
  srRS,
} from "@mui/material/locale";
import bnDate from "date-fns/locale/bn";
import enUSDate from "date-fns/locale/en-US";
import frDate from "date-fns/locale/fr";
import esDate from "date-fns/locale/es";
import zhHKDate from "date-fns/locale/zh-HK";
import arSADate from "date-fns/locale/ar-SA";
import uk from "date-fns/locale/uk";
import de from "date-fns/locale/de";
// import hi from "date-fns/locale/hi";
import plDate from "date-fns/locale/pl";
import trDate from "date-fns/locale/tr";
import ja from "date-fns/locale/ja";
import it from "date-fns/locale/it";
import pt from "date-fns/locale/pt";
import el from "date-fns/locale/el";
import af from "date-fns/locale/af";
import ro from "date-fns/locale/ro";
import hr from "date-fns/locale/hr";
import sr from "date-fns/locale/sr";

const DEFAULT_LANGUAGE = "en";

const languageMap = {
  en: {
    label: "English",
    dir: "ltr",
    mui: enUS,
    locale: "en",
    val: "English",
    name: "language_english",
  },
  fr: {
    label: "Français",
    dir: "ltr",
    mui: frFR,
    locale: "fr",
    val: "French",
    name: "language_french",
  },
};

const allLanguageMap = {
  af: {
    label: "Afrikaans",
    dir: "ltr",
    // mui: ,
    datepicker: af,
    val: "Afrikaans",
    name: "language_afrikaans",
  },
  ar: {
    label: "Arabic",
    dir: "ltr",
    mui: arSD,
    datepicker: enUSDate,
    val: "Arabic",
    name: "language_arabic",
  },
  bn: {
    label: "Bengali",
    dir: "ltr",
    mui: bnBD,
    datepicker: bnDate,
    val: "Bengali",
    name: "language_bengali",
  },
  en: {
    label: "English",
    dir: "ltr",
    mui: enUS,
    datepicker: enUSDate,
    val: "English",
    name: "language_english",
  },
  fr: {
    label: "Français",
    dir: "ltr",
    mui: frFR,
    datepicker: frDate,
    val: "French",
    name: "language_french",
  },
  sp: {
    label: "Spanish",
    dir: "ltr",
    mui: esES,
    datepicker: esDate,
    val: "Spanish",
    name: "language_spanish",
  },
  ca: {
    label: "Cantonese",
    dir: "ltr",
    mui: zhHK,
    datepicker: zhHKDate,
    val: "Cantonese",
    name: "language_cantonese",
  },
  da: {
    label: "Dari",
    dir: "ltr",
    mui: arSD,
    datepicker: arSADate,
    val: "Dari",
    name: "language_dari",
  },

  hr: {
    label: "Croatian",
    dir: "ltr",
    mui: hrHR,
    datepicker: hr,
    val: "Croatian",
    name: "language_croatian",
  },

  hi: {
    label: "Hindi",
    dir: "ltr",
    mui: arSD,
    datepicker: arSADate,
    val: "Hindi",
    name: "language_hindi",
  },
  ma: {
    label: "Mandarin",
    dir: "ltr",
    mui: arSD,
    datepicker: arSADate,
    val: "Mandarin",
    name: "language_mandarin",
  },
  ur: {
    label: "Urdu",
    dir: "ltr",
    mui: arSD,
    datepicker: arSADate,
    val: "Urdu",
    name: "language_urdu",
  },
  ua: {
    label: "Ukrainian",
    dir: "ltr",
    mui: ukUA,
    datepicker: uk,
    val: "Ukrainian",
    name: "language_ukrainian",
  },
  tl: {
    label: "Tagalog",
    dir: "ltr",
    // mui: tlTL,  can't be found
    datepicker: zhHKDate,
    val: "Tagalog",
    name: "language_tagalog",
  },
  de: {
    label: "German",
    dir: "ltr",
    mui: de,
    // datepicker: ,
    val: "German",
    name: "language_german",
  },
  pb: {
    label: "Punjabi",
    dir: "ltr",
    // mui: ,
    datepicker: arSADate,
    val: "Punjabi",
    name: "language_punjabi",
  },
  tr: {
    label: "Turkish",
    dir: "ltr",
    // mui: ,
    datepicker: trDate,
    val: "Turkish",
    name: "language_turkish",
  },
  pl: {
    label: "Polish",
    dir: "ltr",
    // mui: ,
    datepicker: plDate,
    val: "Polish",
    name: "language_polish",
  },
  jp: {
    label: "Japanese",
    dir: "ltr",
    // mui: ,
    datepicker: ja,
    val: "Japanese",
    name: "language_japanese",
  },
  it: {
    label: "Italian",
    dir: "ltr",
    // mui: ,
    datepicker: it,
    val: "Italian",
    name: "language_italian",
  },
  pt: {
    label: "Portuguese",
    dir: "ltr",
    // mui: ,
    datepicker: pt,
    val: "Portuguese",
    name: "language_portuguese",
  },
  fa: {
    label: "Persian",
    dir: "ltr",
    // mui: ,
    datepicker: pt,
    val: "Persian",
    name: "language_persian",
  },

  kr: {
    label: "Korean",
    dir: "ltr",
    // mui: ,
    datepicker: koKR,
    val: "Korean",
    name: "language_korean",
  },

  kek: {
    label: "Q'eqchi'",
    dir: "ltr",
    // mui,
    datepicker: enUSDate,
    val: "Q'eqchi'",
    name: "language_q'eqchi'",
  },

  el: {
    label: "Greek",
    dir: "ltr",
    // mui: ,
    datepicker: el,
    val: "Greek",
    name: "language_greek",
  },
  gr: {
    label: "Gujarati",
    dir: "ltr",
    // mui: ,
    datepicker: el,
    val: "Gujarati",
    name: "language_gujarati",
  },

  ta: {
    label: "Tamil",
    dir: "ltr",
    // mui: ,
    datepicker: el,
    val: "Tamil",
    name: "language_tamil",
  },

  vtm: {
    label: "Vietnamese",
    dir: "ltr",
    // mui: ,
    datepicker: el,
    val: "Vietnamese",
    name: "language_vietnamese",
  },

  ro: {
    label: "Romanian",
    dir: "ltr",
    mui: roRO,
    datepicker: ro,
    val: "Romanian",
    name: "language_romanian",
  },

  rs: {
    label: "Russian",
    dir: "ltr",
    // mui: ,
    datepicker: el,
    val: "Russian",
    name: "language_russian",
  },

  so: {
    label: "Somali",
    dir: "ltr",
    // mui: ,
    datepicker: enUSDate,
    val: "Somali",
    name: "language_somali",
  },

  sr: {
    label: "Serbian",
    dir: "ltr",
    mui: srRS,
    datepicker: sr,
    val: "Serbian",
    name: "language_serbian",
  },

  sw: {
    label: "Swahili",
    dir: "ltr",
    // mui: ,
    datepicker: enUSDate,
    val: "Swahili",
    name: "language_swahili",
  },

  // ti: {
  //   label: "Tigrinya",
  //   dir: "ltr",
  //   // mui: ,
  //   datepicker: enUSDate,
  //   val: "Tigrinya",
  //   name: "language_tigrinya",
  // },

  zl: {
    label: "Zulu",
    dir: "ltr",
    // mui: ,
    datepicker: el,
    val: "Zulu",
    name: "language_zulu",
  },
};

const availableLanguages = Object.keys(languageMap);

export { DEFAULT_LANGUAGE, languageMap, availableLanguages, allLanguageMap };
